var UniqueID = function () {
    return '_' + Math.random().toString(36).substr(2, 9);
};

class Processor {
    constructor(){
        this.processors = [];
    }
    registerProcessor(fn){
        this.processors.push(fn);
    }
    run(context){
        this.processors.forEach(function(fn, i) {
            fn.apply(context, context);
        });
    }
}

export const processor = new Processor();

export default processor;